import { render, staticRenderFns } from "./NoAccount.vue?vue&type=template&id=4697cb88&"
import script from "./NoAccount.vue?vue&type=script&lang=js&"
export * from "./NoAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports